import { axiosClient } from '@nx-frontend/shared/api';
import { UpdateTaskResponse } from '@nx-frontend/shared/types';

interface UpdateTaskParams {
  gatewayUrl: string;
  workspaceId: string;
  taskId: string;
  sessionId: string;
  data: {
    task?: {
      title?: string;
      taskListId?: string;
      done?: boolean;
      deadlineDate?: number;
      showTime?: boolean;
    };
    assignees?: { userId: number }[];
    reminders?: {
      globalId: string;
      beforeValue: number;
      beforeUnit: string;
    }[];
    labels?: {
      labelId: string;
    }[];
  };
}

export async function updateTaskById({
  workspaceId,
  taskId,
  sessionId,
  gatewayUrl,
  data,
}: UpdateTaskParams): Promise<UpdateTaskResponse | null> {
  try {
    const response = await axiosClient.post<UpdateTaskResponse>(
      `${gatewayUrl}/ft:tasks/workspaces/${workspaceId}/tasks/${taskId}`,
      {
        ...data,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'everhelper-session-id': sessionId,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error('Fail to update task by ', taskId, ' id');
  }
  return null;
}
